module.exports = __webpack_public_path__ + "img/11_25.f1ece2fe.png";